module.exports = __webpack_public_path__ + "static/media/banner_overlay.ab2e3677.svg";